import React, { useRef, useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

function AppPrivacyPage() {
  const [selectedImage, setSelectedImage] = React.useState(null);

  return (
    <div
      style={{
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        color: "#4b3621",
        backgroundColor: "#ffffff",
        minHeight: "100vh",
      }}
    >
      <Navbar currentPath="/app" />

      {/* 下载区 */}
      <section
        id="download"
        style={{
          backgroundColor: "#ffffff",
          color: "#4b3621",
          textAlign: "center",
          padding: "4rem 0",
        }}
      >
        <div
          style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "1rem",
              color: "#8b4513",
            }}
          >
            隐私政策
          </h2>
          <p
            style={{
              fontSize: "1.25rem",
              marginBottom: "2rem",
              opacity: 0.9,
              color: "#7a6650",
            }}
          >
            <h1>隐私政策与数据安全</h1>

            <p>本应用（思考链条 / Please No Hostility）尊重并保护您的隐私。</p>

            <h2>1. 数据存储</h2>
            <p>
              所有思考链条、节点、标签与附件均仅存储在您的设备本地 或您授权的
              iCloud 容器中，我们不会上传您的任何内容到服务器。
            </p>

            <h2>2. 订阅与支付</h2>
            <p>
              应用内订阅通过 Apple StoreKit 完成，支付凭证由 Apple 直接处理，
              我们仅接收订阅状态，不接触您的支付密码或银行卡信息。
            </p>

            <h2>3. 第三方 SDK</h2>
            <p>
              我们可能使用 Apple 提供的 CloudKit、StoreKit 等服务，
              其数据处理遵循 Apple 的隐私政策。
            </p>

            <h2>4. 用户权利</h2>
            <p>您可以随时卸载应用、关闭 iCloud 同步或在系统设置中管理订阅。</p>
          </p>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default AppPrivacyPage;
